/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-08 11:34:11
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-10-09 14:08:09
 * @name: 通讯录对象
 * @Description: 通讯录对象
 * @FilePath: \preSaleNafterSaleBackstage\src\object\mailList\mailList.class.js
 * @Author: DESKTOP-1QU67QM
 */
import debounce from "lodash/debounce";
import { departmentGetList, departmentAdd, departmentEdit, departmentDelete, userGetList, userGetAllList, userAdd, userEdit, userDelete, userDepartmentChange, roleGetList, userGetVerifyList, userVerify } from "@/api/mailList/mailList.api.js";
import { apiMethod } from '@/utils/decorator.js';

const mailList = class mailList {
    constructor() {
        this.treeData = []; //树内容
        this.treeNode = []; //选中的树节点信息
        this.peopleData = []; //人员内容
        this.peopleDataLoading = []; //人员内容加载中
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取树内容
     */
    @apiMethod(departmentGetList)
    getTreeList(res) {
        if (res.code === 200) {
            this.treeData = res.data;
            this.setLevelNname();
        }
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 设置部门级别
     */
    setLevelNname() {
        const deepSet = (arr, i) => {
            for (let x in arr) {
                arr[x].level = i;
                arr[x].name = `${arr[x].department_name}(${arr[x].department_user_count}人)`;
                if (arr[x].child && arr[x].child.length > 0) {
                    deepSet(arr[x].child, i + 1);
                }
            }
        }
        deepSet(this.treeData, 1)
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 激活节点
     * @param {Object} data 激活的节点数据
     */
    activeTreeNode(data) {
        this.treeNode = data;
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取部门人员
     * @param {Object} params 查询条件
     * @return {Promise} resolve: 成功回调, reject: 失败回调
     */
    getPeople = debounce((params) => {
        let { id } = params;
        // 表格loading开始
        this.peopleDataLoading.findIndex(x => x.id === id) === -1 && this.peopleDataLoading.push({ id, loading: true });
        this.peopleDataLoading.findIndex(x => x.id === id) > -1 && (this.peopleDataLoading[this.peopleDataLoading.findIndex(x => x.id === id)].loading = true);
        return new Promise((resolve, reject) => {
            let { id: department_id, keyword, page, limit } = params
            userGetList({ department_id, keyword, page, limit }).then(res => {
                let arr = res.data.data;
                let total = res.data.total;
                if (this.peopleData.findIndex(x => x.id === id) > -1) {
                    this.peopleData[this.peopleData.findIndex(x => x.id === id)].list = arr;
                    this.peopleData[this.peopleData.findIndex(x => x.id === id)].dataCount = total;
                }
                this.peopleData.findIndex(x => x.id === id) === -1 && (this.peopleData.push({
                    id,
                    list: arr,
                    dataCount: total,
                }))
                resolve(res);
            }).catch(err => {
                reject(err);
            }).finally(() => {
                // 表格loading结束
                this.peopleDataLoading[this.peopleDataLoading.findIndex(x => x.id === id)].loading = false;
            })
        })
    }, 500, {
        leading: true,
        trailing: true
    })
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 删除部门
     */
    @apiMethod(departmentDelete)
    async deleteItem(res) {
        if (res.code === 200) {
            await this.getTreeList(); //删除后重新获取树信息
            this.activeTreeNode(this.treeData[0]); //激活第一个节点
        }
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 修改部门信息
     * @param {Object} obj 变更内容
     * @return {Promise} resolve: 成功回调, reject: 失败回调
     */
    @apiMethod(departmentEdit)
    async editItem(res) {
        if (res.code === 200) {
            await this.getTreeList(); //添加后重新获取树信息
            this.updateTreeNode(); //更新当前激活的节点
        }
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 添加部门
     * @param {Object} obj 添加内容
     * @return {Promise} resolve: 成功回调, reject: 失败回调
     */
    @apiMethod(departmentAdd)
    addItem(res) {
        if (res.code === 200) {
            this.getTreeList().then(res1 => {
                this.updateTreeNode(); //更新当前激活的节点
            }); //添加后重新获取树信息
        }
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 更新激活节点信息
     */
    updateTreeNode() {
        let id = this.treeNode.id;
        const treeNode = this.getNodeById(id);
        this.treeNode = treeNode;
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 按id获取部门信息
     * @param {Number} id 部门id
     * @return {Object} 激活节点对象
     */
    getNodeById(id) {
        let treeNode = {};
        const treeData = this.treeData; //树信息
        const deepFind = (arr) => {
            for (let x in arr) {
                if (arr[x].id === id) {
                    treeNode = arr[x];
                    return;
                }
                if (arr[x].child && arr[x].child.length > 0) {
                    deepFind(arr[x].child);
                }
            }
        };
        deepFind(treeData); //递归处理树信息,获取到树激活节点当前最新数据
        return treeNode;
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取上级部门
     * @param {Number} id 部门id
     */
    getParent(id) {
        let treeNode = {};
        const treeData = this.treeData; //树信息
        const deepFind = (arr) => {
            for (let x in arr) {
                if (arr[x].child?.findIndex(x => x.id === id) > -1) {
                    treeNode = arr[x];
                    return;
                }
                if (arr[x].child && arr[x].child.length > 0) {
                    deepFind(arr[x].child);
                }
            }
        };
        deepFind(treeData); //递归处理树信息,获取到树激活节点当前最新数据
        return treeNode;
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取所有的节点及当前节点
     * @return {Object} -> {all{Array}: 所有部门 [] => {Object} -> {id{Number}: 部门id, name{String}: 部门名称}, me{Number}: 当前部门id}
     */
    getAllNodeNnow() {
        let all = []; //所有部门
        let me = this.treeNode.id; //当前部门id
        let treeData = this.treeData; //树信息
        const deepFind = (arr) => {
            for (let x in arr) {
                all.push({ id: arr[x].id, department_name: arr[x].department_name, level: arr[x].level, parent_id: arr[x].parent_id });
                if (arr[x].child && arr[x].child.length > 0) {
                    deepFind(arr[x].child);
                }
            }
        };
        deepFind(treeData); //递归处理树信息,将所有部门放入all数组
        return { all, me };
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 删除人员
     * @param {Array} arr 人员id数组
     * @return {Promise} resolve: 成功回调, reject: 失败回调
     */
    @apiMethod(userDelete)
    delPeople(res) { }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 添加人员
     * @param {Object} obj 人员信息
     * @return {Promise} resolve: 成功回调, reject: 失败回调
     */
    @apiMethod(userAdd)
    addPeople(res) { }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 编辑人员
     * @param {Object} obj 人员信息
     * @return {Promise} resolve: 成功回调, reject: 失败回调
     */
    @apiMethod(userEdit)
    editPeople(res) { }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 人员批量调整部门
     */
    @apiMethod(userDepartmentChange)
    jurisdictionPeople(res) { }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 设置密码
     * @param {Object} obj 密码信息
     * @return {Promise} resolve: 成功回调, reject: 失败回调
     */
    setPassword(obj) {
        return new Promise((resolve, reject) => {
            console.log(obj);
            resolve();
        })
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取所有人员
     * @param {String} role_id 职位id
     */
    @apiMethod(userGetAllList)
    getAllPeople(res) { }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取职位列表
     */
    @apiMethod(roleGetList)
    getRoleList(res) { }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取待审核人员列表
     */
    @apiMethod(userGetVerifyList)
    userGetVerifyList(res) { }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 审核人员
     */
    @apiMethod(userVerify)
    userVerify(res) { }
}

export default mailList;